module.exports = __webpack_public_path__ + "static/media/bensound-endlessmotion.b6df2d07.mp3";